<ng-container *ngIf="!(reportSubmittedSuccess || reportSubmittedError)">
  <h1> Report incorrect details for '{{ personFullName || (place && place.practiceName) }}' </h1>
  <p>
    <strong>If the details for this place or person aren't right, let us know by completing the details below.</strong>
  </p>
  <p>
    <strong>Note:</strong> if you need to contact this person/place now, please try their website (if listed) to find
    their contact details. We appreciate you taking the time to report the error(s) to us so we can correct them.
  </p>
  <hr />
  <p>I am a...</p>
  <form>
    <ul class="plain-list report-type-list">
      <li>
        <label (click)="selectReportType(0)" [ngClass]="{ 'radio-label': true, checked: reportType === 0 }"
          ><input type="radio" name="user" value="User" /> Southern Cross member or public user</label
        >
      </li>
      <li>
        <label (click)="selectReportType(1)" [ngClass]="{ 'radio-label': true, checked: reportType === 1 }"
          ><input type="radio" name="user" value="Provider" /> Healthcare provider</label
        >
      </li>
    </ul>

    <div *ngIf="reportType === 0">
      <p>
        <strong>The following details are incorrect:</strong>
      </p>
      <ul class="plain-list report-items" *ngIf="person">
        <li>
          <label class="chk-label"
            ><input
              type="checkbox"
              name="personName"
              value="{{ personFullName }}"
              (change)="optionCheck($event, reportItem.name)" />
            {{ personFullName }}</label
          >
        </li>
        <li *ngFor="let phone of person.phones; let i = index">
          <label class="chk-label"
            ><input
              type="checkbox"
              name="personPhone{{ i + 1 }}"
              value="{{ phone.description ? phone.description + ':' : '' }}{{ phone.number }}"
              (change)="optionCheck($event, reportItem.phone)" />
            <span class="ic-phone"
              ><span *ngIf="phone.description">{{ phone.description }}: </span>{{ phone.number }}</span
            ></label
          >
        </li>
        <li *ngIf="person.fax">
          <label class="chk-label"
            ><input
              type="checkbox"
              name="personFax"
              value="{{ person.fax }}"
              (change)="optionCheck($event, reportItem.fax)" />
            <span class="ic-fax">{{ person.fax }}</span></label
          >
        </li>
        <li *ngIf="person.webAddress">
          <label class="chk-label"
            ><input
              type="checkbox"
              name="personWebAddress"
              value="{{ person.webAddress }}"
              (change)="optionCheck($event, reportItem.web)" />
            <span class="ic-web">{{ person.webAddress | webAddress }}</span></label
          >
        </li>
        <li *ngIf="person.emailAddress">
          <label class="chk-label"
            ><input
              type="checkbox"
              name="personEmailAddress"
              value="{{ person.emailAddress }}"
              (change)="optionCheck($event, reportItem.email)" />
            <span class="ic-email">{{ person.emailAddress }}</span></label
          >
        </li>
      </ul>
      <ul class="plain-list report-items" *ngIf="place">
        <li>
          <label class="chk-label"
            ><input
              type="checkbox"
              name="placeName"
              value="{{ place.practiceName }}"
              (change)="optionCheck($event, reportItem.name)" />
            {{ place.practiceName }}</label
          >
        </li>
        <ng-container *ngIf="place.phones && place.phones.length">
          <li *ngFor="let phone of place.phones; let i = index">
            <label class="chk-label">
              <input
                type="checkbox"
                name="placePhone{{ i + 1 }}"
                value="{{ phone }}"
                (change)="optionCheck($event, reportItem.phone)" />
              <span class="ic-phone">{{ phone }}</span>
            </label>
          </li>
        </ng-container>
        <li *ngIf="place.fax">
          <label class="chk-label">
            <input
              type="checkbox"
              name="placeFax"
              value="{{ place.fax }}"
              (change)="optionCheck($event, reportItem.fax)" />
            <span class="ic-fax">{{ place.fax }}</span>
          </label>
        </li>
        <li *ngIf="place.address">
          <label class="chk-label chk-top">
            <input
              type="checkbox"
              name="placeAddress"
              value="{{
                place.facilityName +
                  '|' +
                  place.receptionLocation +
                  '|' +
                  place.address +
                  '|' +
                  place.suburb +
                  '|' +
                  place.city +
                  '|' +
                  place.postcode
              }}"
              class="place-address-checkbox"
              (change)="optionCheck($event, reportItem.address)" />
            <span class="ic-address">
              <span class="facility-name" *ngIf="place.facilityName">{{ place.facilityName }}</span>
              <span *ngIf="place.receptionLocation">{{ place.receptionLocation }}</span>
              {{ place.address }}
              <span *ngIf="place.suburb">{{ place.suburb }}</span>
              <span *ngIf="place.city || place.postcode">{{ place.city }} {{ place.postcode }}</span>
            </span>
          </label>
        </li>
        <li *ngIf="place.webAddress">
          <label class="chk-label"
            ><input
              type="checkbox"
              name="placeWebAddress"
              value="{{ place.webAddress }}"
              (change)="optionCheck($event, reportItem.web)" />
            <span class="ic-web">{{ place.webAddress | webAddress }}</span></label
          >
        </li>
        <li *ngIf="place.emailAddress">
          <label class="chk-label"
            ><input
              type="checkbox"
              name="placeEmailAddress"
              value="{{ place.emailAddress }}"
              (change)="optionCheck($event, reportItem.email)" />
            <span class="ic-email">{{ place.emailAddress }}</span></label
          >
        </li>
      </ul>
      <re-captcha
        class="recaptcha"
        (resolved)="captchaResolved($event)"
        siteKey="6LdrA7oSAAAAAMeKymyfE6CMI96G_jKqPetSlaxX"></re-captcha>
      <p>
        <input
          type="button"
          value="Submit"
          [ngClass]="{
            'btn-primary': true,
            'btn-primary-disabled': !formIsValid(),
          }"
          (click)="reportIncorrectDetails()" />
      </p>
      <p class="last">
        If you need assistance please call us on
        <span class="phone">0800 800 181</span>. We're here to help between 8am to 6pm, Monday to Friday.
      </p>
    </div>
    <div *ngIf="reportType === 1">
      <p class="contact-us last">
        To update your personal or practice details, please email:<br /><a
          href="mailto:provider.update@southerncross.co.nz"
          >provider.update&#64;southerncross.co.nz</a
        >
      </p>
    </div>
  </form>
</ng-container>
<div class="success" *ngIf="reportSubmittedSuccess">
  <h1 class="ic-success">Success</h1>
  <p class="success-text"> Your request has been submitted to Southern Cross for review.<br />Thanks for your help! </p>
  <p><a class="link-btn-primary" (click)="done()">Done</a></p>
</div>
<div class="error" *ngIf="reportSubmittedError">
  <h1 class="ic-error">Error</h1>
  <p class="error-text"> Something went wrong and we couldn't submit your request.<br />Please try again. </p>
  <p><a class="link-btn-primary" (click)="tryAgain()">Try again</a></p>
</div>
